import React, { Component } from 'react';
import { connect } from "react-redux";

import langApi from "../api/langApi";
import store from '../store/configureStore';
import { lang } from "../config/lang";
import { addNotification } from "../actions/notificationAction";
import { changeLanguageAction } from '../actions/langAction';
import $ from "jquery"

/****************************************
    Language Menu
    @author  IMH003
    @date    2020.05.13
    @version 0.1    
 ******************************************/
const title = {
    en: 'DPR Korea Tour',
    kp: '조선관광',
    cn: '朝鲜旅游',
    ru: 'Туризм в КНДР',
    jp: '朝鮮観光'
}

class LangMenu extends Component {

    constructor(props) {
        super(props);
        var current_lang = localStorage.getItem('language');
        this.state = {
            arrLangMenu: [],
            current_lang: (current_lang === undefined || current_lang === null) ? 'en' : current_lang
        }
        this.updateFontStyle = this.updateFontStyle.bind(this);
        this.onChangeLang = this.onChangeLang.bind(this);
        this.buildLangMenuFromWeb = this.buildLangMenuFromWeb.bind(this);
    }


    componentWillMount(nextState) {
        var current_lang = localStorage.getItem('language');
        this.state = {
            arrLangMenu: [],
            current_lang: (current_lang === undefined || current_lang === null) ? 'en' : current_lang
        }
        this.buildLangMenuFromWeb(this.state.current_lang);
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
        // $('title').text(title[nextState.current_lang]);
    }

    componentWillUnmount() {
    }

    componentWillReceiveProps(newProps) {
        if (this.state.current_lang !== newProps.language.lang_key) {
            this.buildLangMenuFromWeb(newProps.language.lang_key);
        }
    }

    updateFontStyle(lang_key) {
        var fontFamily = 'Arial'
        if (lang_key === 'kp') {
            fontFamily = "PRK P Gothic";
        } else if (lang_key === 'en') {
            fontFamily = "Arial";
        } else if (lang_key === 'ru') {
            fontFamily = "Times New Roman";
        } else if (lang_key === 'cn') {
            fontFamily = "Sim Sun";
        } else if (lang_key === 'jp') {
            fontFamily = "MS Mincho";
        }

        document.body.style.fontFamily = fontFamily;
    }

    onChangeLang(lang_key) {
        if (lang_key === this.state.current_lang) {
            return;
        }

        localStorage.setItem('language', lang_key);
        this.buildLangMenuFromWeb(lang_key);
        store.dispatch(changeLanguageAction(lang_key));
    }

    buildLangMenuFromWeb(lang_key) {
        langApi.getLangTypes(lang_key).then((json) => {
            if (json.status === 200 && json.data) {
                this.setState({
                    current_lang: lang_key,
                    arrLangMenu: json.data
                })
                $('title').text(title[lang_key]);
                this.updateFontStyle(lang_key);
            } else {
                store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
            }
        })
    }

    render() {
        var filter = { code: this.state.current_lang };
        var activeLang = this.state.arrLangMenu.filter(function (item) {
            for (var key in filter) {
                if (item[key] !== undefined && item[key] === filter[key])
                    return true;
            }
            return false;
        });
        return (
            <li className="dropdown" style={{ cursor: 'pointer' }}>
                <div className="dropdown-toggle nav-link lang-menu-div" data-toggle="dropdown">
                    <span>{activeLang.length > 0 ? activeLang[0].title : ''}</span>
                </div>
                <ul className="dropdown-menu">
                    {
                        this.state.arrLangMenu.map((langType, key) => (
                            <li  onClick={() => this.onChangeLang(langType.code)} style={{textAlign: 'center'}} className="nav-item" key={key}>
                                <span>{langType.title}</span>
                            </li>
                        ))
                    }
                </ul>
            </li>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language
    };
}

export default connect(mapStateToProps)(LangMenu);